export const LOAD_MESSAGES_START = 'I18N_LOAD_MESSAGES_START'
export const LOAD_MESSAGES_FINISH = 'I18N_LOAD_MESSAGES_FINISH'
export const CHANGE_LOCALE = 'I18N_CHANGE_LOCALE'
export const SYNC_I18N = 'I18N_SYNC_I18N'

export const LOAD_TUTORIAL_MESSAGES_START = 'I18N_LOAD_TUTORIAL_MESSAGES_START'
export const LOAD_TUTORIAL_MESSAGES_FINISH = 'I18N_LOAD_TUTORIAL_MESSAGES_FINISH'

export const loadI18nMessagesStart = (locale) => {
  return { type: LOAD_MESSAGES_START, data: locale }
}
export const loadI18nMessagesFinish = (locale, messages) => {
  return { type: LOAD_MESSAGES_FINISH, data: { locale, messages } }
}
export const changeLocale = (locale) => {
  return { type: CHANGE_LOCALE, data: locale }
}
export const syncI18n = () => {
  return { type: SYNC_I18N }
}
export const loadI18nTutorialMessagesStart = (locale) => {
  return { type: LOAD_TUTORIAL_MESSAGES_START, data: locale }
}
export const loadI18nTutorialMessagesFinish = (locale, messages) => {
  return { type: LOAD_TUTORIAL_MESSAGES_FINISH, data: { locale, messages } }
}
